import { Component } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
  selector: '[custom-toastr-component]',
  styleUrls: [`./custom-toastr.component.scss`],
  templateUrl: `./custom-toastr.component.html`
})
export class CustomToastrComponent extends Toast {
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }
  /**
   * @param  {} {this.toastrService.clear}
   */
  dismissToastr() {
    this.toastrService.clear();
  }
}